<template>
   <v-container fluid>
      <v-sheet outlined :class="PadForMobile">
         <!-- <v-card outlined v-if="display_notification">
            <div v-if="unapproved_transaction" class="px-5 py-2 red white--text">
               You have paid activities that are pending approval. You can only make payment for
               approved activities.
            </div>
            <div v-if="unpaid_transaction" class="px-5 py-2 red white--text">
               You have unpaid transactions. Please make your payment online to ensure your child's
               participation.
            </div>
         </v-card> -->

         <v-tabs
            height="50"
            v-model="parenttab"
            :slider-color="$globalstore.tab_slidercolor"
            :show-arrows="!$vuetify.breakpoint.mdAndUp"
         >
            <v-tab href="#today">Today</v-tab>
            <v-tab href="#group">{{ GroupSubscribeTab }}</v-tab>
            <v-tab href="#consent">
               Consent
               <v-badge
                  v-if="consentdata && consentdata.length > 0"
                  :content="ConsentBadgeCount"
                  color="red"
                  class="ml-2"
               >
               </v-badge>
            </v-tab>
            <v-tab href="#fullterm">{{ TermScheduleTab }}</v-tab>
         </v-tabs>
         <v-tabs-items v-model="parenttab">
            <v-tab-item :key="1" value="today">
               <v-col md="6">
                  <v-expansion-panels v-model="todaypanel" multiple>
                     <v-expansion-panel v-for="child in childrendata" :key="child.school_id">
                        <v-expansion-panel-header>
                           {{ child.fullname }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                           <v-data-table
                              dense
                              :items="child.eventdata"
                              :headers="event_headers"
                              @click:row="todayRowClick"
                              item-key="event_id"
                              hide-default-footer
                              single-select
                              no-data-text="No activity scheduled."
                           >
                           </v-data-table>
                        </v-expansion-panel-content>
                     </v-expansion-panel>
                  </v-expansion-panels>
               </v-col>
            </v-tab-item>
            <v-tab-item :key="2" value="group">
               <v-row>
                  <v-col cols="12">
                     <v-card class="pa-5">
                        By subscribing to the following activities, you are giving your consent for
                        your children or charges to participate in the subscribed activities. Please
                        complete the subscription by selecting the Consent tab and follow the
                        instructions to approve the subscription.
                     </v-card>
                  </v-col>
               </v-row>
               <v-row align="stretch">
                  <v-col cols="12" class="d-flex flex-column">
                     <v-expansion-panels v-model="subpanel" multiple>
                        <v-expansion-panel v-for="child in subgroupdata" :key="child.school_id">
                           <v-expansion-panel-header>
                              <v-row>
                                 <v-col cols="12" md="4">
                                    <label class="font-weight-bold">
                                       {{ child.fullname }}
                                    </label>
                                 </v-col>
                              </v-row>
                           </v-expansion-panel-header>
                           <v-expansion-panel-content v-if="child.groupdata">
                              <v-card
                                 class="d-flex flex-column mb-3"
                                 outlined
                                 v-for="(grp, i) in child.groupdata"
                                 :key="i"
                              >
                                 <v-row no-gutters align="stretch">
                                    <v-col cols="12" md="3" class="d-flex flex-column">
                                       <v-card class="flex d-flex flex-column">
                                          <span class="ml-1 font-weight-medium ">
                                             {{ grp.cca_name }}
                                             <template v-if="grp.consent_required">
                                                **
                                             </template>
                                          </span>
                                          <span class="ml-1">
                                             {{ grp.cca_description | ellipsetext(100) }}
                                             <template v-if="grp.cca_description.length > 100">
                                                <v-btn
                                                   x-small
                                                   outlined
                                                   color="indigo"
                                                   @click="showMore(grp.cca_description)"
                                                   >More</v-btn
                                                >
                                             </template>
                                          </span>
                                          <span class="ml-1">
                                             Fee: RM {{ $globalstore.formatCurrency(grp.cca_fee) }}
                                          </span>
                                       </v-card>
                                    </v-col>
                                    <v-col cols="12" md="3" class="d-flex flex-column">
                                       <v-card class="flex d-flex flex-column">
                                          <div v-for="(evt, j) in grp.eventdata" :key="j">
                                             <span class="ml-1"> Day: {{ evt.daytext }} </span>
                                             <br />
                                             <span class="ml-1"> Time: {{ evt.timetext }} </span>
                                             <br />
                                             <span class="ml-1">
                                                Location:
                                                {{ evt.location_name }}
                                             </span>
                                          </div>
                                       </v-card>
                                    </v-col>
                                    <v-col cols="12" md="2" class="d-flex flex-column">
                                       <v-card class="flex d-flex flex-column">
                                          <div>
                                             <span class="ml-1">
                                                Max:
                                                {{ grp.max_participant }} </span
                                             ><br />
                                             <span class="ml-1">
                                                Subscribers:
                                                {{ grp.participantcount }}</span
                                             ><br />
                                             <span class="ml-1">
                                                Waitlist:
                                                {{ grp.waitlistcount }}</span
                                             >
                                          </div>
                                       </v-card>
                                    </v-col>
                                    <v-col cols="12" md="4" class="d-flex flex-column">
                                       <v-card class="flex d-flex flex-column">
                                          <v-switch
                                             class="ml-1 my-0"
                                             color="teal darken-1"
                                             :disabled="
                                                DisableSubscriptionChange(grp, child.school_id)
                                             "
                                             v-model="grp.subscribed"
                                             :label="GetSubscriptionLabel(grp)"
                                             @click="
                                                subscriptionSwitch(
                                                   child.school_id,
                                                   grp.cca_id,
                                                   grp.subscribed,
                                                   grp,
                                                )
                                             "
                                          >
                                          </v-switch>

                                          <v-switch
                                             class="ml-1 my-0"
                                             color="teal"
                                             :disabled="DisableWaitListChange(grp, child.school_id)"
                                             v-model="grp.waitlisted"
                                             :label="GetWaitListLabel(grp)"
                                             @click="
                                                waitListSwitch(
                                                   child.school_id,
                                                   grp.cca_id,
                                                   grp.waitlisted,
                                                   grp,
                                                )
                                             "
                                          >
                                          </v-switch>
                                       </v-card>
                                    </v-col>
                                 </v-row>
                              </v-card>
                           </v-expansion-panel-content>
                           <v-expansion-panel-content v-else>
                              <span>No activities available for subscription. </span>
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                     </v-expansion-panels>
                  </v-col>
               </v-row>
            </v-tab-item>
            <v-tab-item :key="3" value="consent">
               <v-row>
                  <v-col cols="12" md="12">
                     <v-card class="pa-5">
                        Please use the following to approve your child(ren) or ward's subscription.
                        Click the Approve button followed by the I Agree button to approve their
                        participation and grant Consent and Indemnity in the selected activity. If
                        payment is required, click on the Payment button to pay online. Students
                        will not be allowed to participate in the selected activity if payment have
                        not been made. Click the Reject button if you do not want your child(ren) or
                        ward to participate in the selected activity.
                     </v-card>
                  </v-col>
               </v-row>
               <v-row no-gutters class="py-2">
                  <v-col cols="12" md="12">
                     <v-btn
                        small
                        outlined
                        color="indigo"
                        class="ml-4 pa-2"
                        @click="loadConsentData"
                     >
                        <v-icon left>mdi-refresh</v-icon>
                        <template v-if="$vuetify.breakpoint.mdAndUp">Refresh</template>
                     </v-btn>
                  </v-col>
               </v-row>
               <v-data-table
                  dense
                  :items="consentdata"
                  :headers="consent_headers"
                  item-key="consent_id"
                  single-select
                  @click:row="consentRowClick"
                  :items-per-page="-1"
                  hide-default-footer
               >
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.cca_fee="{item}">
                     <div class="py-2">{{ $globalstore.formatCurrency(item.cca_fee) }}</div>
                  </template>
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.actions="{item}">
                     <span class="pr-1">
                        <v-btn
                           :disabled="item.consent_status == 1"
                           small
                           width="90px"
                           outlined
                           color="teal"
                           @click="approveSubscription(item)"
                        >
                           <template v-if="item.consent_status == 1">
                              <v-icon small>mdi-check</v-icon>Approved
                           </template>
                           <template v-else>
                              Approve
                           </template>
                        </v-btn>
                     </span>
                     <span class="pr-1">
                        <v-btn
                           small
                           width="90px"
                           outlined
                           color="red"
                           @click="rejectSubscription(item)"
                           >Reject</v-btn
                        >
                     </span>
                     <template v-if="item.cca_fee &gt; 0">
                        <template v-if="item.ccatran && item.ccatran.pendingtransaction">
                           <span>Processing Payment</span>
                        </template>
                        <template v-else>
                           <span class="pr-1">
                              <v-btn
                                 :disabled="item.consent_status !== 1"
                                 small
                                 width="90px"
                                 outlined
                                 color="primary"
                                 @click="goPaymentPortal"
                                 >Payment</v-btn
                              >
                           </span>
                        </template>
                     </template>
                  </template>
               </v-data-table>
            </v-tab-item>
            <v-tab-item :key="4" value="fullterm">
               <v-col cols="12" md="12">
                  <v-data-table
                     dense
                     ref="fullterm"
                     :caption="TermCaption"
                     :items="termdata"
                     :headers="term_headers"
                     item-key="uniqueid"
                     :group-by="groupbykey"
                     :sort-by="sortbykey"
                     @click:row="termRowClick"
                     single-select
                     :items-per-page="-1"
                  >
                     <!-- eslint-disable-next-line -->
                     <template #group.header="{ items, isOpen, toggle }">
                        <th colspan="12">
                           <v-icon small @click="toggle" class="material-icons"
                              >{{ isOpen ? "expand_more" : "expand_less" }}
                           </v-icon>
                           <span class="ml-2">Name: {{ items[0].fullname }}</span>
                        </th>
                     </template>
                  </v-data-table>
               </v-col>
            </v-tab-item>
         </v-tabs-items>
         <api-loading :apiCall.sync="apiCall"></api-loading>
      </v-sheet>
      <v-dialog v-model="showMoreDlg" max-width="400px">
         <v-card>
            <v-card-title>Description</v-card-title>
            <v-card-text>{{ moredescription }}</v-card-text>
         </v-card>
      </v-dialog>
      <show-toast ref="toast"></show-toast>
      <confirm-dlg ref="confirm"></confirm-dlg>
      <release-indemnity-dlg ref="releaseindemnity"></release-indemnity-dlg>
   </v-container>
</template>

<script>
   import GlobalConstant from "@/common/globalconstant.js";
   import ApiLoading from "@/components/ApiLoading.vue";
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ShowToast from "@/components/showToast.vue";
   import ReleaseIndemnityDlg from "@/components/ReleaseIndemnityDlg.vue";
   import {SubscriptionType} from "@/common/constant.js";

   export default {
      inject: ["ShowMessage"],

      components: {ConfirmDlg, ApiLoading, ShowToast, ReleaseIndemnityDlg},
      data() {
         return {
            subscriptionType: SubscriptionType,
            portalwinref: null,
            parenttab: "today",
            childrendata: [],
            subgroupdata: [],
            MAX_CCA: 0,
            todaypanel: [],
            subpanel: [],
            apiCall: false,
            groupbykey: "fullname",
            sortbykey: "fullname",
            expandedview: [],
            singleExpand: true,
            // unpaid_transaction: false,
            // unapproved_transaction: false,
            // display_notification: false,

            event_headers: [
               {
                  text: "Name",
                  value: "cca_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Time",
                  value: "timetext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            termdata: [],
            term_headers: [
               {
                  text: "Day",
                  value: "daytext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Date",
                  value: "event_date",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Name",
                  value: "fullname",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Activity",
                  value: "cca_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Time",
                  value: "timetext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            consentdata: [],
            consent_headers: [
               {
                  text: "Name",
                  value: "fullname",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Group",
                  value: "cca_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Date",
                  value: "requestdate",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Request",
                  value: "requesttext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Fee",
                  value: "cca_fee",
                  align: "end",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Action",
                  value: "actions",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            parentlink: -1,

            moredescription: "",
            showMoreDlg: false,
         };
      },
      computed: {
         ConsentBadgeCount() {
            if (this.consentdata) {
               return this.consentdata.length;
            }
         },

         TermCaption() {
            return (
               "Full Term Schedule for " +
               this.$globalstore.appsettings.currentyearterm.termyeartext
            );
         },

         GroupSubscribeTab() {
            return this.$vuetify.breakpoint.mobile ? "Sub Group" : "Subscribe Group";
         },

         TermScheduleTab() {
            return this.$vuetify.breakpoint.mobile ? "Schedule" : "Term Schedule";
         },

         PadForMobile() {
            return this.$vuetify.breakpoint.mobile ? "ml-5 mt-8" : "ml-5 mt-5";
         },
      },

      methods: {
         ChildProfileComplete(schoolid) {
            let child = this.childrendata.find((x) => x.school_id === schoolid);

            return child.profiledata.profile_complete;
         },

         showMore(text) {
            this.moredescription = text;
            this.showMoreDlg = true;
         },

         getSubcriptionCount(schoolid) {
            let count = 0;
            for (let i = 0; i < this.subgroupdata.length; i++) {
               if (this.subgroupdata[i].school_id == schoolid) {
                  let groups = this.subgroupdata[i].groupdata;
                  if (groups) {
                     for (let j = 0; j < groups.length; j++) {
                        // any other value means don't count as cca
                        if (groups[j].count_cca == 1) {
                           if (groups[j].subscribed) {
                              count = count + 1;
                           }
                        }
                     }
                  }
               }
            }
            return count;
         },

         DisableSubscriptionChange(grp, schoolid) {
            if (grp.waitlisted) return true;

            // Parent unsubscribe by rejecting the subscription
            if (grp.subscribed && grp.pcp_subtype == this.subscriptionType.TYPE_INVITATION)
               return true;

            if (
               grp.max_participant > 0 &&
               grp.max_participant == grp.participantcount &&
               !grp.subscribed
            )
               return true;

            // Parent unsubscribe by rejecting the subscription
            if (grp.pcp_consentid && grp.pcp_consentstatus == 0) return true;

            // if paid, don't allow unsubscribe.
            if (grp.ccatran) return true;

            return false;
         },

         GetSubscriptionLabel(grp) {
            if (grp.subscribed) {
               if (grp.ccatran) {
                  if (grp.pcp_consentstatus == 0) {
                     return "Subscribed and pending approval.";
                  } else if (grp.pcp_consentstatus == 1) {
                     if (!grp.ccatran.paid_date) {
                        if (grp.ccatran.invoice_no) {
                           return "Subscribed and invoiced.";
                        } else {
                           return "Subscribed and pending payment.";
                        }
                     } else if (grp.ccatran.paid_date) {
                        return "Subscribed and paid.";
                     }
                  }
               } else if (grp.pcp_consentid) {
                  if (grp.pcp_consentstatus == 1) {
                     return "Subscribed and approved.";
                  } else if (grp.pcp_consentstatus == 0) {
                     return "Subscribed pending approval.";
                  } else {
                     return "Subscribed.";
                  }
               } else {
                  return "Subscribed.";
               }
            } else {
               return "Not subscribed.";
            }
         },

         GetWaitListLabel(grp) {
            if (grp.waitlisted) {
               if (grp.wait_consentid) {
                  if (grp.wait_consentstatus == 0) {
                     return "On Wait List pending approval";
                  } else if (grp.wait_consentstatus == 1) {
                     return "On Wait List and approved";
                  }
               } else {
                  return "On Wait List";
               }
            } else {
               return "Not On Wait List";
            }
         },

         DisableWaitListChange(grp, schoolid) {
            if (grp.subscribed) return true;

            if (grp.wait_consentid && grp.wait_consentstatus == 0) return true;

            return false;
         },

         waitListSwitch(schoolid, ccaid, subvalue, grp) {
            if (subvalue) {
               if (grp.cca_fee > 0) {
                  this.$refs.confirm
                     .open(
                        "Payment",
                        "This activity requires payment to be made upon participation. Are you sure you wish to join the wait list?",
                        {color: "green", noconfirm: false},
                     )
                     .then((reply) => {
                        if (reply) {
                           this.saveWaitList(schoolid, ccaid, subvalue, grp);
                           this.updateGroupStat();
                        } else {
                           this.revertWaitList(schoolid, ccaid, subvalue);
                        }
                     });
               } else {
                  this.saveWaitList(schoolid, ccaid, subvalue, grp);
               }
            } else {
               this.saveWaitList(schoolid, ccaid, subvalue, grp);
            }
         },

         subscriptionSwitch(schoolid, ccaid, subvalue, grp) {
            if (subvalue) {
               if (grp.count_cca == 1) {
                  let subcount = this.getSubcriptionCount(schoolid);

                  if (this.MAX_CCA == 0 || (this.MAX_CCA > 0 && subcount <= this.MAX_CCA)) {
                     if (grp.cca_fee > 0) {
                        this.$refs.confirm
                           .open(
                              "Payment",
                              "This activity requires payment to be made for participation. Are you sure you wish to subscribe?",
                              {color: "green", noconfirm: false},
                           )
                           .then((reply) => {
                              if (reply) {
                                 this.saveSubscription(schoolid, ccaid, subvalue, grp);
                                 this.updateGroupStat();
                              } else {
                                 this.revertSubscription(schoolid, ccaid, subvalue);
                              }
                           });
                     } else {
                        this.saveSubscription(schoolid, ccaid, subvalue, grp);
                        this.updateGroupStat();
                     }
                  } else {
                     this.$refs.confirm
                        .open(
                           "Info",
                           "You are limited to a maximum of " +
                              this.$globalstore.appsettings.max_cca_per_student +
                              " activity this term",
                           {color: "primary", noconfirm: true},
                        )
                        .then((reply) => {
                           this.revertSubscription(schoolid, ccaid, subvalue);
                        });
                  }
               } else {
                  if (grp.cca_fee > 0) {
                     this.$refs.confirm
                        .open(
                           "Payment",
                           "This activity requires payment to be made for participation. Are you sure you wish to subscribe?",
                           {color: "green", noconfirm: false},
                        )
                        .then((reply) => {
                           if (reply) {
                              this.saveSubscription(schoolid, ccaid, subvalue, grp);
                              this.updateGroupStat();
                           } else {
                              this.revertSubscription(schoolid, ccaid, subvalue);
                           }
                        });
                  } else {
                     this.saveSubscription(schoolid, ccaid, subvalue, grp);
                     this.updateGroupStat();
                  }
               }
            } else {
               this.RemoveSubscription(schoolid, ccaid, subvalue, grp);
            }
         },

         todayRowClick(item, row) {
            row.select(!row.isSelected);
         },

         termRowClick(item, row) {
            row.select(!row.isSelected);
         },

         consentRowClick(item, row) {
            row.select(!row.isSelected);
         },

         async loadConsentData() {
            await this.$http({
               url: "/cca/getconsentlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  contact_id: this.parentlink,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.consentdata = response.data.consentdata;
                  }
               }
            });
         },

         async saveSubscription(schoolid, ccaid, subvalue, grp) {
            await this.$http({
               url: "/cca/subscribegroup.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  school_id: schoolid,
                  cca_id: ccaid,
                  sub: subvalue,
                  consentid: grp.pcp_consentid,
                  consentstatus: grp.pcp_consentstatus,
                  parent: true,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else if (response.data.subscriptionfailed) {
                     this.$refs.confirm
                        .open("Info", response.data.message, {
                           color: "primary",
                           noconfirm: true,
                        })
                        .then((reply) => {
                           this.revertSubscription(schoolid, ccaid, subvalue);
                           this.$refs.toast.display({
                              message: "Subscription failed.",
                              color: this.$globalstore.toast_errorclass,
                           });
                           this.updateGroupStat();
                        });
                  } else if (response.data.conflict) {
                     let cft = this.buildConflictTable(response.data.conflictdata);
                     this.$refs.confirm
                        .open(
                           "Error",
                           "This subscription clashes with your existing subscriptions.<br>" + cft,
                           {color: "red", noconfirm: true},
                        )
                        .then((reply) => {
                           this.revertSubscription(schoolid, ccaid, subvalue);
                           this.$refs.toast.display({
                              message: "Subscription failed.",
                              color: this.$globalstore.toast_errorclass,
                           });
                           this.updateGroupStat();
                        });
                  } else {
                     this.loadAvailableSubGroup();
                     this.loadConsentData();
                     this.$refs.toast.display({
                        message: "Subscription successful.",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         buildConflictTable(data) {
            if (data.length > 0) {
               let cft = "<table>";
               for (let i = 0; i < data.length; i++) {
                  cft += "<tr><td colspan='2' width='100%'>" + data[i].cca_name + "</td></tr>";
                  cft += "<tr><td width='40%'>" + data[i].event_daytext + "</td>";
                  cft += "<td width='60%'>" + data[i].event_time + "</td></tr>";
               }
               cft += "</table>";
               return cft;
            } else {
               return "";
            }
         },

         async RemoveSubscription(schoolid, ccaid, subvalue, grp) {
            await this.$http({
               url: "/cca/unsubscribegroup.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  school_id: schoolid,
                  cca_id: ccaid,
                  unsub: subvalue,
                  consentid: grp.pcp_consentid,
                  consentstatus: grp.pcp_consentstatus,
                  parent: true,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else if (response.data.unsubscribefailed) {
                     this.$refs.confirm
                        .open("Info", response.data.message, {
                           color: "primary",
                           noconfirm: true,
                        })
                        .then((reply) => {
                           this.revertSubscription(schoolid, ccaid, subvalue);
                           this.$refs.toast.display({
                              message: "Unsubscribe failed.",
                              color: this.$globalstore.toast_errorclass,
                           });
                           this.updateGroupStat();
                        });
                  } else {
                     this.loadAvailableSubGroup();
                     this.$refs.toast.display({
                        message: "Unsubscribe successful.",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         revertSubscription(schoolid, ccaid, subvalue) {
            for (let i = 0; i < this.subgroupdata.length; i++) {
               if (this.subgroupdata[i].school_id == schoolid) {
                  let groups = this.subgroupdata[i].groupdata;
                  if (groups) {
                     for (let j = 0; j < groups.length; j++) {
                        if (groups[j].cca_id == ccaid) {
                           this.$set(groups[j], "subscribed", !subvalue);
                           this.$set(groups[j], "waitlisted", !subvalue);
                        }
                     }
                  }
               }
            }
         },

         revertWaitList(schoolid, ccaid, subvalue) {
            for (let i = 0; i < this.subgroupdata.length; i++) {
               if (this.subgroupdata[i].school_id == schoolid) {
                  let groups = this.subgroupdata[i].groupdata;
                  if (groups) {
                     for (let j = 0; j < groups.length; j++) {
                        if (groups[j].cca_id == ccaid) {
                           this.$set(groups[j], "waitlisted", !subvalue);
                        }
                     }
                  }
               }
            }
         },

         // updateSubscription(schoolid, ccaid, subvalue) {
         //    for (let i = 0; i < this.subgroupdata.length; i++) {
         //       if (this.subgroupdata[i].school_id == schoolid) {
         //          let groups = this.subgroupdata[i].groupdata;
         //          for (let j = 0; j < groups.length; j++) {
         //             if (groups[j].cca_id == ccaid) {
         //                groups[j].subscribed = subvalue;
         //                if (groups[j].consent_required) {
         //                   groups[j].consentstatus = subvalue ? 1 : null;
         //                }
         //             }
         //          }
         //       }
         //    }
         // },

         // updateWaitList(schoolid, ccaid, subvalue) {
         //    for (let i = 0; i < this.subgroupdata.length; i++) {
         //       if (this.subgroupdata[i].school_id == schoolid) {
         //          let groups = this.subgroupdata[i].groupdata;
         //          for (let j = 0; j < groups.length; j++) {
         //             if (groups[j].cca_id == ccaid) {
         //                groups[j].waitlisted = subvalue;
         //                if (groups[j].consent_required) {
         //                   groups[j].consentstatus = subvalue ? 1 : null;
         //                }
         //             }
         //          }
         //       }
         //    }
         // },

         async saveWaitList(schoolid, ccaid, subvalue, grp) {
            await this.$http({
               url: "/cca/subscribewaitlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  school_id: schoolid,
                  cca_id: ccaid,
                  sub: subvalue,
                  consentid: grp.wait_consentid,
                  consentstatus: grp.wait_consentstatus,
                  parent: true,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error || response.data.subscriptionfailed) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     let msg = subvalue
                        ? "Waitlist subscription successful."
                        : "Unsubscribed from Waitlist successful.";
                     this.$refs.toast.display({
                        message: msg,
                        color: this.$globalstore.toast_successclass,
                     });
                     this.loadAvailableSubGroup();
                  }
               }
            });
         },

         extractSubGroupID() {
            // Pull group id to use for retrieving groupstats
            let grparray = [];
            for (let i = 0; i < this.subgroupdata.length; i++) {
               let grps = this.subgroupdata[i].groupdata;
               if (grps) {
                  for (let j = 0; j < grps.length; j++) {
                     if (!grparray.some((x) => x == grps[j].cca_id)) {
                        grparray.push(grps[j].cca_id);
                     }
                  }
               }
            }
            return grparray;
         },

         async updateGroupStat() {
            let grparray = this.extractSubGroupID();

            await this.$http({
               url: "/cca/groupsubstats.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  groups: grparray,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     let groupstat = response.data.groupstat;
                     for (let i = 0; i < this.subgroupdata.length; i++) {
                        let grps = this.subgroupdata[i].groupdata;
                        if (grps) {
                           for (let j = 0; j < grps.length; j++) {
                              let index = groupstat.findIndex((x) => x.cca_id == grps[j].cca_id);
                              if (index !== -1) {
                                 grps[j].participantcount = groupstat[index].participantcount;
                                 grps[j].waitlistcount = groupstat[index].waitlistcount;
                              }
                           }
                        }
                     }
                  }
               }
            });
         },

         async goPaymentPortal() {
            let token = localStorage.getItem("usertoken");
            await this.$http({
               url: "/common/checkuserlogin.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },

               data: {
                  userid: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.userloggedin) {
                  if (token) {
                     let url =
                        GlobalConstant.PORTAL_URL + "?usertoken=" + token + "&ccapayment=yes";
                     let winref = window.open(url, "_top");
                     // Object.assign(document.createElement("a"), {
                     //    target: "_blank",
                     //    href: url,
                     // }).click();
                  } else {
                     this.$globalstore.user.tokenexpired = true;
                  }
               } else {
                  this.$globalstore.user.tokenexpired = true;
               }
            });
         },

         async doApprovePaidCCA(item) {
            await this.$http({
               url: "/cca/approvepaidcca.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  consentdata: item,
                  cca_id: item.cca_id,
                  school_id: item.school_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.loadConsentData();
                     this.loadAvailableSubGroup();
                     this.$refs.toast.display({
                        message: "Subscription approved.",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async approveSubscription(item) {
            await this.$refs.releaseindemnity.open("Consent and Indemnity").then((reply) => {
               if (reply) {
                  this.doApproveSubscription(item);
               }
            });
         },

         async doApproveSubscription(item) {
            await this.$http({
               url: "/cca/approvesubscription.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  consentdata: item,
                  cca_id: item.cca_id,
                  school_id: item.school_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.loadConsentData();
                     this.loadAvailableSubGroup();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async rejectSubscription(item) {
            await this.$http({
               url: "/cca/rejectsubscription.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  consentdata: item,
                  cca_id: item.cca_id,
                  school_id: item.school_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.loadConsentData();
                     this.loadAvailableSubGroup();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_errorclass,
                     });
                  }
               }
            });
         },

         async loadChildrenTodayList() {
            if (this.parentlink) {
               await this.$http({
                  url: "/cca/getchildrentodaylist_bycontactid.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     contactid: this.parentlink,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.childrendata = response.data.childrendata;
                        if (this.childrendata.length <= 2) {
                           this.todaypanel = this.childrendata.map((obj, i) => i);
                        }
                     }
                  }
               });
            }
         },

         async loadAvailableSubGroup() {
            await this.$http({
               url: "/cca/groupsub_bycontactid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  contactid: this.parentlink,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.subgroupdata = response.data.childrendata;
                  }
               }
            });
         },

         async loadFullTerm() {
            await this.$http({
               url: "/cca/getchildrenfullterm.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  contactid: this.parentlink,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.termdata = response.data.termdata;
                     if (this.termdata.length == 0) {
                        this.$refs.toast.display({
                           message: response.data.message,
                           color: this.$globalstore.toast_warningclass,
                        });
                     } else {
                        // Expand the first child.
                        this.expandedview.push(this.termdata[0].uniqueid);
                     }
                  }
               }
            });
         },

         async checkChildrenProfile() {
            await this.$http({
               url: "/cca/profile_needupdate.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  contact_id: this.parentlink,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     if (response.data.needupdate) {
                        this.$refs.confirm
                           .open(
                              "Student Profile",
                              "One or more of your children's profile needs updating. Click OK to update their profile",
                              {
                                 color: "primary",
                                 noconfirm: false,
                              },
                           )
                           .then((reply) => {
                              if (reply) {
                                 this.$router.push({name: "StudentProfile"});
                              }
                           });
                        // this.ShowMessage({
                        //    title: "Information",
                        //    message: response.data.message,
                        //    color: "success",
                        // });
                     }
                  }
               }
            });
         },

         // async checkOutstandingTransaction() {
         //    await this.$http({
         //       url: "/cca/checkoutstandingtransaction.php",
         //       headers: {"Content-Type": "application/x-www-form-urlencoded"},
         //       data: {
         //          contact_id: this.parentlink,
         //          userid: this.$globalstore.user.userid,
         //          token: this.$globalstore.user.usertoken,
         //       },
         //       method: "POST",
         //    }).then((response) => {
         //       this.unpaid_transaction = response.data.hasOutStandingTransaction;
         //       this.unapproved_transaction = response.data.hasUnApprovedTransaction;
         //       if (this.unapproved_transaction || this.unpaid_transaction) {
         //          this.display_notification = true;
         //       } else {
         //          this.display_notification = false;
         //       }
         //    });
         // },
      },

      async mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.parentlink = this.$globalstore.user.userlinkid;
            this.MAX_CCA = this.$globalstore.appsettings.max_cca_per_student;
            await this.loadChildrenTodayList();
            await this.loadAvailableSubGroup();
            await this.loadConsentData();
            await this.loadFullTerm();
            // await this.checkOutstandingTransaction();
            await this.checkChildrenProfile();
         }
      },
   };
</script>
